/**
 * Returns a canonical URL
 * @param channelId
 * @param webcastId
 */
const getCanonicalUrl = (hostUrl = '', channelId: string, webcastId: string) => {

  return `${hostUrl || process.env.HOST}/webcast/${channelId}/${webcastId}`

}

export default getCanonicalUrl
